import { useProducts } from "./useProducts";

const POPULAR_TAG_NAME = "人気・おすすめ";

export const usePopularProducts = () => {
  return useProducts({ tag: POPULAR_TAG_NAME });
};
